import { RouteItem } from '../menu/routes'

export const redirectToUrl = (
  routes: RouteItem[],
  customUrl?: string,
): string => {
  if (customUrl) {
    return customUrl
  }

  if (routes.find((r) => r.url === '/dashboard')) {
    return '/dashboard'
  }

  const route = routes?.find((r) => r.sidebar)

  return route?.url || '/'
}
